import React, { type PropsWithChildren } from 'react';

import { Grid, Box } from '@atlaskit/primitives/compiled';

import { cssMap, cx } from '@atlaskit/css';

import { Controls } from '../../onboarding-grid/content-layout-section/controls/index.tsx';
import { ControlItem } from '../../onboarding-grid/content-layout-section/controls/control-item/index.tsx';
import { ExitButton } from '../../onboarding-grid/exit-button/index.tsx';
import { ImageLayoutSection } from './create-form-image-layout-section/index.tsx';
import { ContentLayoutSection } from './create-form-content-layout-section/index.tsx';

const CreateFormOnboardingGridContainerStyles = cssMap({
	grid: {
		gridTemplateColumns: '1fr 1fr',
	},
	root: {
		height: '100%',
		maxHeight: '100%',
		maxWidth: '100%',
		position: 'relative',
	},
});

type CreateFormOnboardingGridType = {
	enableCrossButton: boolean;
	onClose?: () => void;
};

const CreateFormOnboardingGrid = ({
	children,
	enableCrossButton = true,
	onClose,
}: PropsWithChildren<CreateFormOnboardingGridType>): React.JSX.Element => {
	return (
		<Box xcss={CreateFormOnboardingGridContainerStyles.root}>
			<Grid xcss={cx(CreateFormOnboardingGridContainerStyles.grid)}>{children}</Grid>
			{enableCrossButton && onClose && <ExitButton onClose={onClose} />}
		</Box>
	);
};

CreateFormOnboardingGrid.ContentSection = ContentLayoutSection;
CreateFormOnboardingGrid.ImageSection = ImageLayoutSection;

CreateFormOnboardingGrid.Controls = Controls;
CreateFormOnboardingGrid.ControlItem = ControlItem;

export { CreateFormOnboardingGrid };
